var Category;
(function(Category) {
    Category["ContactLenses"] = 'Contact-Lenses';
    Category["Sunglasses"] = "Sunglasses";
    Category["Optical"] = "Optical";
    Category["Accessories"] = "Accessories";
    Category["Solutions"] = "Solutions";
    Category["ReadyReaders"] = 'Ready-readers';
})(Category || (Category = {}));
var LineItemType;
(function(LineItemType) {
    LineItemType["Single"] = 'single';
    LineItemType["Subscription"] = 'subscription';
    LineItemType["Bundle"] = 'bundle';
})(LineItemType || (LineItemType = {}));
var PurchaseType;
(function(PurchaseType) {
    PurchaseType["OneTime"] = 'one-time';
    PurchaseType["Subscription"] = 'subscription';
})(PurchaseType || (PurchaseType = {}));
var BrandType;
(function(BrandType) {
    BrandType["OwnBrand"] = 'own brand';
    BrandType["ExternalBrand"] = 'external brand';
})(BrandType || (BrandType = {}));
var Stock;
(function(Stock) {
    Stock["InStock"] = 'in stock';
    Stock["OutOfStock"] = 'out of stock';
})(Stock || (Stock = {}));
var GlassLensPrescriptionType;
(function(GlassLensPrescriptionType) {
    GlassLensPrescriptionType["Prescription"] = 'prescription lenses';
    GlassLensPrescriptionType["NonPrescription"] = 'non-prescription lenses';
})(GlassLensPrescriptionType || (GlassLensPrescriptionType = {}));
var EventType;
(function(EventType) {
    EventType["add"] = "add";
    EventType["remove"] = "remove";
    EventType["checkout"] = "checkout";
    EventType["purchase"] = "purchase";
})(EventType || (EventType = {}));

export { BrandType, Category, EventType, GlassLensPrescriptionType, LineItemType, PurchaseType, Stock };
//# sourceMappingURL=types.js.map
